<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ifMJB2/tc-custom/9781250152497.jpg?1724845482382" alt="This image is the cover for the book Glass House"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Glass House
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Beatrice Colin's <i>The Glass House</i> is a gorgeously transporting novel filled with turn-of-the-century detail and lush blooms, about two women from vastly different worlds</b><br/><br/>Scotland, 1912. Antonia McCulloch’s life hasn’t gone the way she planned. She and her husband, Malcolm, have drifted apart; her burgeoning art career came to nothing; and when she looks in the mirror, she sees disappointment. But at least she will always have Balmarra, her family’s grand Scottish estate, and its exquisite glass house, filled with exotic plants that can take her far away. <br/><br/>When her estranged brother’s wife, Cicely Pick, arrives unannounced, with her young daughter and enough trunks to last the summer, Antonia is instantly suspicious. What besides an inheritance dispute could have brought her glamorous sister-in-law all the way from India? Still, Cicely introduces excitement and intrigue into Antonia’s life, and, as they get to know one another, Antonia realizes that Cicely has her own burdens to bear. Slowly, a fragile friendship grows between them. But when the secrets each are keeping become too explosive to conceal, the truth threatens their uneasy balance and the course of their entire lives.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Beatrice Colin
      </h2>
      
      <p class="authorDescription body article">Beatrice Colin was a novelist based in Glasgow. <I>The Glimmer Palace </I>(2008), a novel set in Berlin in the early 20th century, was translated into eight languages, was a Richard and Judy pick, and was short-listed for several major awards. Colin also wrote radio plays and adaptations for BBC Radio 4.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Flatiron Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7c681822